import { AvailabilitiesResponse } from "@/types/responses";

export const getAvailablePackagesWiyp = (availResponse: AvailabilitiesResponse) => {
    const availablePackageCodeWiyp: { codePackage: string, prestId: string, maxPromo: number }[] = []
    availResponse.availablePackages!.forEach(availablePackage => {
        availablePackageCodeWiyp.push({ codePackage: availablePackage.codePackage!, prestId: availablePackage.prestId! as string, maxPromo: 0 })
    });
    availResponse.prestations!.forEach(prestation => {
        availablePackageCodeWiyp.push({ codePackage: prestation.codePackage!, prestId: prestation.prestId!, maxPromo: 0 })
    });
    // Ensure only unique codePackage/prestId combinations
    const uniqueMap = new Map();
    for (const entry of availablePackageCodeWiyp) {
        const key = `${entry.codePackage}-${entry.prestId}`;
        if (!uniqueMap.has(key)) {
            uniqueMap.set(key, entry);
        }
    }
    return Array.from(uniqueMap.values())
}